import {AppBar, IconButton, Link, ListItemIcon, ListItemText, Menu, MenuItem, Toolbar} from "@mui/material";
import {Call, DarkMode, Home, Info, LightMode, Menu as MenuIcon, Message, Photo} from "@mui/icons-material";
import Typography from "@mui/material/Typography";
import {useEffect, useRef, useState} from "react";
import {useNavigate} from "react-router";
import route from "../../../../enum/route";
import isNull from "../../../../mixin/isNull";
import database from "../../../../database/database";
import useEventDispatcher from "../../../../use/useEventDispatcher";
import useSecurity from "../../../../use/useSecurity";
import useClientRepository from "../../../../repository/b2csdu/useClientRepository";
import useAddressRepository from "../../../../repository/b2csdu/useAddressRepository";
import useOrderRepository from "../../../../repository/b2csdu/useOrderRepository";
import useHelper from "../../../../use/useHelper";

export default function ({orderId, clientId, onLetMessageClicked, onOpenAddress, onOpenPictures}) {
    const security = useSecurity();
    const helper = useHelper();
    const eventDispatcher = useEventDispatcher();
    const navigate = useNavigate();
    const clientRepository = useClientRepository();
    const addressRepository = useAddressRepository();
    const orderRepository = useOrderRepository();
    /** @type Client */
    const client = clientRepository.findOneById(clientId).select();
    /** @type Address */
    const address = addressRepository.findOneByOrderId(orderId).select();
    /** @type Order */
    const order = orderRepository.findOneById(orderId).select();
    const [anchorEl, setAnchorEl] = useState(null);
    const googleMapLink = useRef();

    useEffect(() => {
        clientRepository.findOneById(clientId).exec();
        addressRepository.findOneByOrderId(orderId).exec();
        orderRepository.findOneById(orderId).exec();
    }, []);

    const handleMenu = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => setAnchorEl(null);

    const handleHome = () => {
        navigate(route.ARTISAN_INTERVENTIONS);
        handleClose();
    }

    const handleTheme = theme => () => {
        eventDispatcher.launcher("toggle-mode", {
            mode: theme
        });
        handleClose();
    }

    const handleOpenCompanySpace = () => {
        window.open(`${process.env.REACT_APP_COMPANY_SPACE_URL}#access_token=${database.read(database.TABLE_AUTHENTICATION, "access_token")}`, "_blank", "location=yes");
        handleClose();
    }

    const handleLetMessage = () => {
        onLetMessageClicked();
        handleClose();
    }

    const handleOpenGoogleMap = () => {
        googleMapLink.current.click();
        handleClose();
    }

    const handleOpenAddress = () => {
        onOpenAddress();
        handleClose();
    }

    const handleOpenPictures = () => {
        onOpenPictures();
        handleClose();
    }

    return (
        <AppBar position="sticky" sx={{top: 0}}>
            <Toolbar>
                <Typography
                    component="div"
                    sx={{flexGrow: 1, textTransform: "uppercase"}}
                    fontWeight={"bold"}
                >
                    Dossier {orderId}
                </Typography>
                <div>
                    <IconButton
                        size="large"
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        onClick={handleMenu}
                        color="inherit"
                        data-test="button-menu"
                    >
                        <MenuIcon/>
                    </IconButton>
                    <Menu
                        id="menu-appbar"
                        anchorEl={anchorEl}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        keepMounted
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'right',
                        }}
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                    >
                        <MenuItem onClick={handleLetMessage} data-test="menu-let-message">
                            <ListItemIcon>
                                <Message/>
                            </ListItemIcon>
                            <ListItemText>
                                Nous laisser un message
                            </ListItemText>
                        </MenuItem>
                        <MenuItem onClick={handleClose}>
                            <ListItemIcon>
                                <Call/>
                            </ListItemIcon>
                            <ListItemText>
                                <Link
                                    href={`tel:${client?.getPhone1()}`}
                                    sx={{textDecoration: "none", color: "inherit"}}
                                >
                                    Appeler le sociétaire
                                </Link>
                            </ListItemText>
                        </MenuItem>
                        <MenuItem onClick={handleOpenAddress}>
                            <ListItemIcon>
                                <Info/>
                            </ListItemIcon>
                            <ListItemText>
                                Info sociétaire
                            </ListItemText>
                        </MenuItem>
                        <MenuItem onClick={handleClose}>
                            <ListItemIcon>
                                <Call/>
                            </ListItemIcon>
                            <ListItemText>
                                <Link
                                    href={`tel:${process.env.REACT_APP_FFG_PHONE_NUMBER}`}
                                    sx={{textDecoration: "none", color: "inherit"}}
                                >
                                    Nous contacter
                                </Link>
                            </ListItemText>
                        </MenuItem>
                        <MenuItem onClick={handleOpenPictures}>
                            <ListItemIcon>
                                <Photo/>
                            </ListItemIcon>
                            <ListItemText>
                                Photos dossier SOS
                            </ListItemText>
                        </MenuItem>
                        <MenuItem onClick={handleHome} data-test="menu-back">
                            <ListItemIcon>
                                <Home/>
                            </ListItemIcon>
                            <ListItemText>
                                Revenir à l'accueil
                            </ListItemText>
                        </MenuItem>
                        {
                            /**
                             <MenuItem
                             disabled={!security.roles.includes(role.ENTREPRENEUR)}
                             onClick={handleOpenCompanySpace}
                             >
                             <ListItemIcon>
                             <AccountBox/>
                             </ListItemIcon>
                             <ListItemText>
                             Mon espace
                             </ListItemText>
                             </MenuItem>
                             */
                        }
                        {
                            !isNull(database.read(database.TABLE_THEME, "dark"))
                            && database.read(database.TABLE_THEME, "dark") === "dark"
                                ? <MenuItem onClick={handleTheme("light")}>
                                    <ListItemIcon>
                                        <LightMode/>
                                    </ListItemIcon>
                                    <ListItemText>
                                        Theme blanc
                                    </ListItemText>
                                </MenuItem>
                                : <MenuItem onClick={handleTheme("dark")}>
                                    <ListItemIcon>
                                        <DarkMode/>
                                    </ListItemIcon>
                                    <ListItemText>
                                        Theme sombre
                                    </ListItemText>
                                </MenuItem>
                        }
                    </Menu>
                </div>
            </Toolbar>
        </AppBar>
    );
}